import React, { useCallback, useState } from "react";
import NumberFormat from 'react-number-format';

import {ILabel, Label} from "./Label"

export const InputNumber : React.FC<Props> = (props : Props) : JSX.Element => {


  let [value, setValue] = useState(props.value === undefined ? "" : props.value);
  const onChange = useCallback((event) => { setValue(event.value); }, [value]);

    return (

        <div className="inputNumber">
        { props.label === undefined ?
          null : 
          <Label
            label = {props.label}
            isRequired = {props.isRequired}
          />
        }
        <div className="inputNumber-container">
          <NumberFormat
            className={props.suffix === "" || props.suffix === undefined ? "" : "padding-right"}
            onChange={props.onChange === undefined ? onChange : props.onChange} 
            onBlur={props.onBlur}
            name={props.name}
            id={props.name}
            value={props.onChange === undefined ? value : props.value}
            decimalSeparator={"."}
            thousandSeparator={" "}
             />
            {props.suffix === "" || props.suffix === undefined ? "" : <span className="suffix">{props.suffix}</span> }
        </div>
      </div>

  );    

};


interface Props {
    readonly label : ILabel | undefined;
    readonly isRequired : boolean | undefined;
    readonly onBlur : React.FocusEventHandler<HTMLInputElement> | undefined;
    readonly onChange : React.ChangeEventHandler<HTMLInputElement> | undefined;
    readonly name : string | undefined;
    readonly value : string | undefined;
    readonly suffix : string | undefined;
}